import apiClient from '../apiClient';
import { GET_USER_PROFILE } from '../apiUrl';

const getUserProfile = () => {
  return apiClient.get(GET_USER_PROFILE);
};

export default getUserProfile;
